export default {"src":"/_next/static/media/omnichannel-4.a1ac12ba.svg","height":121,"width":118,"blurWidth":0,"blurHeight":0};